import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceRemoveResourceFromPlanzoneNotificationState = createStateReducer(
  initialState,
  {
    [events.removeResourceFromPlanzoneSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "removeResourceFromPlanzone",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.removeResourceFromPlanzoneFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "removeResourceFromPlanzone",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceRemoveResourceFromPlanzoneNotificationState };
